// extracted by mini-css-extract-plugin
var _1 = "errorBanner--jiEnDzxo";
var _2 = "errorPage--AKKHpmtX";
export { _1 as "errorBanner", _2 as "errorPage" }
